import { Flex, Text } from '@chakra-ui/react';

export const Separator = ({
  separatorConfig = { textStyles: {}, containerStyles: {}, title: '' },
}) => {
  const { textStyles, containerStyles, title } = separatorConfig;
  return (
    <Flex {...containerStyles}>
      <Text {...textStyles}>{title}</Text>
    </Flex>
  );
};
